import React from 'react';
import account, { Account } from './modules/account';
import auth, { Auth } from './modules/auth';
import shinkansen, { Shinkansen } from './modules/shinkansen';

export type RootStore = {
  auth: Auth;
  shinkansen: Shinkansen;
  account: Account;
};

export const store: RootStore = {
  auth,
  shinkansen,
  account
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { auth, shinkansen, account };
